export const service_packages = {
  path: 'service-packages',
  name: 'pbx.service-package.index',
  component: () => import(/* webpackChunkName: 'pbx-packages' */ '@pbx/pages/packages/list'),
  meta: {
    loadable: true,
    title: {
      code: 'pbx.breadcrumb.service-package.index'
    }
  }
};
